export const ExpensesType = {
  getDisplayName(expensesType) {
    return `${expensesType.name_short} (Вид расходов ${expensesType.code})`;
  }
};
